import { defaultIconProps } from 'components/common/icons'
import type { DefaultIconProps } from 'components/common/icons'

export const Tag = ({
  size = defaultIconProps.size,
  className = defaultIconProps.className,
}: DefaultIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    height={size}
    width={size}
    fill="currentColor"
    className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2165 0.31015C15.8404 0.453433 16.4723 0.68775 16.8925 1.10792C17.3126 1.52808 17.547 2.15995 17.6902 2.7838C17.8382 3.42825 17.9109 4.16598 17.941 4.89097C18.0012 6.34308 17.8934 7.82683 17.8237 8.58525C17.7802 9.05858 17.5865 9.49558 17.2842 9.84742C15.0265 12.4743 12.686 14.8658 10.1306 17.1538C8.96129 18.2008 7.21554 18.2118 5.99793 17.2691C3.98985 15.7143 2.28602 14.0105 0.731238 12.0024C-0.211517 10.7848 -0.200413 9.039 0.846513 7.86975C3.13458 5.31435 5.526 2.97394 8.15295 0.716175C8.50479 0.413783 8.94179 0.220158 9.41504 0.176667C10.1735 0.106975 11.6573 -0.000858475 13.1094 0.0593832C13.8344 0.0894665 14.5721 0.162133 15.2165 0.31015ZM14.8336 4.41675C14.8336 3.72639 14.274 3.16675 13.5836 3.16675C12.8933 3.16675 12.3336 3.72639 12.3336 4.41675C12.3336 5.10711 12.8933 5.66675 13.5836 5.66675C14.274 5.66675 14.8336 5.10711 14.8336 4.41675ZM5.42291 10.0775C5.09748 9.75208 4.56984 9.75208 4.2444 10.0775C3.91896 10.4029 3.91896 10.9306 4.2444 11.256L6.7444 13.756C7.06984 14.0814 7.59745 14.0814 7.92295 13.756C8.24837 13.4306 8.24837 12.9029 7.92295 12.5775L5.42291 10.0775Z"
      fill="#0D69C0"
    />
  </svg>
)
